import metaTags from '@/creditflowresearch/ui/common/metaTagsConstants';
import { ProfileTypes } from '@/creditflowresearch/application/actions/profile/constants';
import { IMetaTags, IgetMetaTagsByFilters } from './types';

type TgetPossibleSectorMetaTags = Pick<IgetMetaTagsByFilters, 'profileType' | 'sector'>;

export const getPossibleSectorMetaTags = ({ profileType, sector }: TgetPossibleSectorMetaTags): IMetaTags => {
  if (profileType === ProfileTypes.SECTOR) {
    const sectorName = sector.metaTitleName;

    if (sector.subsectorId) {
      return metaTags.getSectorSubsectorProfile(sectorName);
    }

    return metaTags.getSectorProfile(sectorName);
  }

  return null;
};
